import React from 'react';
import { PrimaryButton, IButtonProps, IButtonStyles } from 'office-ui-fabric-react';
import { theme }                                      from 'theme';


const getButtonStyles = (isPrimary: boolean = true, styles?: IButtonStyles): IButtonStyles => {
  return {
    ...styles,
    root:         {
      backgroundColor: isPrimary ? theme.colors.themePrimary : theme.colors.light,
      color:           isPrimary ? theme.colors.ultraLight : theme.colors.black,
      ...(typeof styles?.root === 'object' ? styles?.root : {}),
    },
    rootDisabled: {
      backgroundColor: theme.colors.light,
      color:           theme.colors.greyUltraLight,
      ...(typeof styles?.rootDisabled === 'object' ? styles?.rootDisabled : {}),
    },
    rootHovered: {
      backgroundColor: isPrimary ? theme.colors.themeDark : theme.colors.ultraLight,
      color:           isPrimary ? theme.colors.ultraLight : theme.colors.black,
      ...(typeof styles?.rootHovered === 'object' ? styles?.rootHovered : {}),
    },
    rootPressed: {
      backgroundColor: isPrimary ? theme.colors.themePrimary : theme.colors.light,
      color:           isPrimary ? theme.colors.ultraLight : theme.colors.black,
      ...(typeof styles?.rootPressed === 'object' ? styles?.rootPressed : {}),
    },
  }
};

const Button: React.FC<IButtonProps & { primaryButton?: boolean; }> = ({
  primaryButton = true,
  ...props
}) => (
  <PrimaryButton {...props} styles={getButtonStyles(primaryButton, props.styles)}>{props.children}</PrimaryButton>
);

export default Button;
